import "./Box.css";
import { Container, Row } from 'react-bootstrap';

export default function Box({ title, description, button, image, onClick }) {
  return (
    <Container className="box drop-shadow">
      <Row className="title">{title}</Row>
      <Row className="description"><b>{description}</b></Row>
      {button && <button className="box-button" onClick={onClick}><div className="box-div"><b>{button}</b></div></button>}
      {image && <img className="box-image" src={image} alt={title} />}
    </Container>
  );
}
